import { VMediumTypeComboBoxModel } from '../vmedium-type-combo-box.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 全媒体区分リストを取得する
 *
 * @export API通信成功時の処理
 * @class GetVMediumListService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetVMediumListService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: VMediumTypeComboBoxModel;
  private orderCode: string = null;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetVMediumListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.orderCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {VMediumTypeComboBoxModel} model
   * @param {string} orderCode
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetCodeListService
   */
  execute(model: VMediumTypeComboBoxModel, orderCode: string, successFunc: Function = null) {
    this.model = model;
    this.orderCode = orderCode;
    this.successFunc = successFunc;
    this.send('KYMW02getVMediumList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCodeListService
   */
  success(data: any) {
    this.model.updateMediumList(data);
    if (this.successFunc !== null) {
      this.successFunc();
    }
  }

}
